"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_common_autocomplete_1 = require("@hotelplan/components.common.autocomplete");
const components_common_lazy_render_1 = require("@hotelplan/components.common.lazy-render");
const TravelDestination_mappers_1 = require("./TravelDestination.mappers");
const TravelDestination_tracking_1 = require("./TravelDestination.tracking");
const TravelDestinationField_1 = __importDefault(require("./TravelDestinationField"));
const GenericTravelDestinationField = (props) => {
    const { queryDocument, disabled, dataMapper, variablesMapper, suggestionMapper, config, limit, customLabel, caption, onSelect, renderSuggestion, } = props;
    return (react_1.default.createElement(TravelDestinationField_1.default, { disabled: disabled, limit: limit, config: config, customLabel: customLabel, caption: caption, onSelect: onSelect, renderSuggestion: renderSuggestion },
        react_1.default.createElement(components_common_autocomplete_1.AutocompleteDataSource, { queryDocument: queryDocument, dataMapper: data => data
                ? {
                    items: dataMapper(data).destinations,
                    page: dataMapper(data).page,
                }
                : undefined, variablesMapper: variables => variablesMapper({
                selected: variables.selected.map(TravelDestination_mappers_1.mapCanonicalDestinationToIDs),
                text: variables.query,
                page: variables.page,
            }), suggestionMapper: suggestionMapper !== null && suggestionMapper !== void 0 ? suggestionMapper : TravelDestination_mappers_1.mapTravelDestinationObjectToCanonical, onCompleted: (completedData, vars) => {
                const text = (vars === null || vars === void 0 ? void 0 : vars.text) || '';
                (0, TravelDestination_tracking_1.trackDestinationsSearchResult)(dataMapper(completedData), text);
            } }),
        props.children));
};
exports.default = (0, components_common_lazy_render_1.withLazyHydrate)(GenericTravelDestinationField, {
    whenIdle: true,
});
//# sourceMappingURL=GenericTravelDestinationField.js.map